import * as React from 'react';
import {useEffect, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {latestPerUoa} from '../../../utils/wia';

interface ISameObjectiveData {
    submissions: any[];
    uoa: string | number
}

// Categorie 1-4 di domanda 18.
const ACTORS = [
    {
        name: 'Beneficiari',
        answer: 'Beneficiari',
    },
    {
        name: 'Finanziamento pubblico',
        answer: 'Finanziamento pubblico',
    },
    {
        name: 'Finanziamento privato/del terzo settore (inclusa Fondazione Cariplo)',
        answer: 'Finanziamento privato/terzo settore (incluso finanziamento Cariplo)',
    },
    {
        name: 'Fundraising',
        answer: 'Fundraising',
    },
];

const contributes = (submission: any, answer: string): boolean =>
    Object.keys(submission)
        .filter((key: string) => key.startsWith('question19_'))
        .some((key: string) => submission[key] === answer);

const ActorSameObjective = ({submissions, uoa}: ISameObjectiveData) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<any[]>([]);

    const calculateSubmissions = () => {
        const latest = latestPerUoa(submissions);
        const currentSubmission = latest.find((submission: any) => submission.uoa_id === uoa);

        if (!currentSubmission) {
            setRows(ACTORS.map(actor => ({name: actor.name, involvement: 'No', value: 0})));
            setLoading(true);

            return;
        }

        const sameObjective = latest.filter(
            (submission: any) => submission.question4 === currentSubmission.question4
        );

        setRows(ACTORS.map(actor => ({
            name: actor.name,
            involvement: contributes(currentSubmission, actor.answer) ? 'Sì' : 'No',
            value: Math.round(
                sameObjective.filter((submission: any) => contributes(submission, actor.answer)).length
                / sameObjective.length * 100
            ),
        })));
        setLoading(true);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card>
            <CardContent>
                {
                    loading && (
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            Contributo finanziario all'attività
                                        </TableCell>
                                        <TableCell align='right'>
                                            % CONTRIBUTO (a confronto con altre attività che hanno la stessa finalità
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        rows.map((row) => (
                                            <TableRow
                                                key={row.name}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                            >
                                                <TableCell>
                                                    {row.name}
                                                </TableCell>
                                                <TableCell>
                                                    {row.involvement}
                                                </TableCell>
                                                <TableCell align='right'>
                                                    {row.value}%
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )
                }
            </CardContent>
        </Card>
    )
}

export default ActorSameObjective;
